export default __webpack_public_path__ + "static/media/PendingColorIcon.56a70337.svg";